import React from 'react';

import {DetailPageReviewSidebarFactory} from 'app/components/general/DetailPageReviewSidebar/DetailPageReviewSidebar';
import {SidebarItem} from 'app/general/structures/SidebarItem';
import {getObjectReviewURL} from 'app/urls';
import {getContentType} from 'app/utils/content-type';
import {gt} from 'app/utils/i18n';

import type {
  LeftSidebarElementType,
  LeftSidebarMenuButton,
  LeftSidebarPanelType,
} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import type {DetailPageItemType} from 'app/components/general/DetailPage/types';
const DetailPageReviewSidebar =
  DetailPageReviewSidebarFactory<DetailPageItemType>();

function ReviewPanelContent<ItemType extends DetailPageItemType>({
  object,
  legacyRefetch,
}: LeftSidebarPanelType<ItemType>) {
  const contentType = getContentType(object.content_type);

  return (
    <DetailPageReviewSidebar
      title={gt('%s Review', contentType.name)}
      object={object}
      contentType={object.content_type}
      versionId={object.current_version.id}
      versionContentType={object.current_version.content_type}
      canReview={object.can_edit}
      onToggleReview={legacyRefetch}
      onReview={legacyRefetch}
    />
  );
}

function ReviewMenuButton<ItemType extends DetailPageItemType>({
  object,
  forceTooltipShow,
  hideTooltip,
  location,
  active,
}: LeftSidebarMenuButton<ItemType>) {
  const contentType = getContentType(object.content_type);
  return (
    <SidebarItem
      disabled={object.approved_at == null}
      disabledTooltipText={gt(
        'Only an approved %s can be reviewed.',
        contentType.name
      )}
      title={gt('Review')}
      active={active}
      icon="fa fa-certificate"
      link={getObjectReviewURL(object, location.search)}
      forceTooltipShow={forceTooltipShow}
      onClick={hideTooltip}
    />
  );
}

export const ReviewSidebar: LeftSidebarElementType<DetailPageItemType> = {
  Panel: ReviewPanelContent,
  MenuButton: ReviewMenuButton,
  type: 'left',
  sidebarName: 'showReview',
};
